<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-align-left`]" width="1em" height="1em" v-bind="$attrs"><path d="M1.96503 1.16992C2.42334 1.17002 2.7951 1.54166 2.7951 2V14C2.7951 14.4583 2.42334 14.83 1.96503 14.8301C1.50663 14.8301 1.13495 14.4584 1.13495 14V2C1.13495 1.5416 1.50663 1.16992 1.96503 1.16992ZM10.3859 11.1699C10.8442 11.1701 11.216 11.5417 11.216 12C11.216 12.4583 10.8442 12.8299 10.3859 12.8301H4.68475V11.1699H10.3859ZM14.8391 7.16992C15.2973 7.17005 15.6691 7.54169 15.6691 8C15.6691 8.45831 15.2973 8.82995 14.8391 8.83008H4.68475V7.16992H14.8391ZM12.2941 3.16992C12.7525 3.16994 13.1242 3.54161 13.1242 4C13.1242 4.45839 12.7525 4.83006 12.2941 4.83008H4.68475V3.16992H12.2941Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineAlignLeft',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
